import React, { useContext } from 'react';
import { Menu } from 'antd';
import { arrayOf, any } from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { UiContext } from '../../../appContext';
import CustomScrollbars from '../../../util/CustomScrollbars';
import SidebarLogo from './SidebarLogo';
import { NAV_STYLE_MINI_SIDEBAR } from '../../../constants/ThemeSetting';
import './styles.less';

const SidebarContent = ({ routes }) => {
  const { uiState: { navStyle } } = useContext(UiContext);
  const { pathname } = useLocation();
  // `/dashboard` on its own has no second segment, so this is undefined on
  // the index route — which used to throw when it was lower-cased.
  const selectedSub = pathname.toLocaleLowerCase().split('/')[2] ?? '';
  const getSubNavStyle = (path) => {
    let style = 'ic-nav-item-sub';
    if (navStyle === NAV_STYLE_MINI_SIDEBAR) {
      style = `${style} mini`;
    }
    if (path === selectedSub) {
      style = `${style} selected`;
    }
    return style;
  };
  const pathToMatch = pathname.substr(1).split('/');
  const match1 = `${pathToMatch[0]}/${pathToMatch[1]}`;
  const match2 = `${match1}/${pathToMatch[2]}`;
  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          {/* An `items` array rather than Menu and SubMenu children, which
              antd 4.20 deprecated. Each label carries its own Link, so the
              nav behaves as before. */}
          <Menu
            selectedKeys={[match1, match2]}
            theme="dark"
            mode="inline"
            items={routes.map(({
              hasSubRoute, icon, title, path, sub,
            }) => (hasSubRoute ? {
              key: path.toLocaleLowerCase(),
              className: getSubNavStyle(path),
              label: (
                <span>
                  {' '}
                  {icon}
                  <span className="item-title">{title}</span>
                </span>
              ),
              children: sub.map(({ title: subtitle, path: subPath, icon: subIcon }) => ({
                key: subPath.substr(1).toLocaleLowerCase(),
                className: 'ic-item-sub',
                label: (
                  <Link to={subPath}>
                    <span>
                      <span className="ic-bar" />
                      {subIcon}
                      <span>{subtitle}</span>
                    </span>
                  </Link>
                ),
              })),
            } : {
              key: path.substr(1).toLocaleLowerCase(),
              className: navStyle === NAV_STYLE_MINI_SIDEBAR ? 'ic-nav-item mini' : 'ic-nav-item',
              label: (
                <Link to={path}>
                  <span className="ic-bar" />
                  {icon}
                  <span>{title}</span>
                </Link>
              ),
            }))}
          />
        </CustomScrollbars>
      </div>
    </>
  );
};

SidebarContent.propTypes = {
  routes: arrayOf(any.isRequired).isRequired,
};

export default SidebarContent;
